import {TagDefinition, TagDefinitionEntity} from "../../../model/tag-definition";
import {makeEntitySelectors} from "../base-entity-store";
import {createParamSelector} from "../../../util/selector-util";

export interface TagDefinitionSelectorProps {
  doNotUse?: boolean;
}

const filter = (v: TagDefinition, props: TagDefinitionSelectorProps) => {
  if (props.doNotUse !== undefined) {
    if (props.doNotUse !== v.doNotUse) {
      return false;
    }
  }

  return true
}

const getDoNotUseParam = createParamSelector<TagDefinitionSelectorProps | undefined, boolean | undefined>(params => params?.doNotUse);

const tagDefinitionSelectors = makeEntitySelectors<
  TagDefinition,
  TagDefinitionEntity,
  TagDefinitionSelectorProps
>({
  defaultProps: {},

  filter: filter,

  transform: (value) => TagDefinitionEntity.from(value),
});

export const tagDefinitionsSelector =
  (props?: TagDefinitionSelectorProps) =>
    tagDefinitionSelectors.listSelector(props);

export const tagDefinitionsSelectorWithParams =
  (props?: TagDefinitionSelectorProps) =>
    tagDefinitionSelectors.listSelectorWithParams(
      [getDoNotUseParam],
      (doNotUse) => ({
        ...props,
        doNotUse: doNotUse,
      })
    );

export const tagDefinitionSelector =
  () => tagDefinitionSelectors.singleSelector();
